// extracted by mini-css-extract-plugin
export default {"root":"TabSection_root__eH7Pi","tabs":"TabSection_tabs__usiNH","content":"TabSection_content__-qxYB"};